import PagesWrapper from "../mainpage/PagesWrapper";
import styles from "./Aktuelles.module.css";
import { Section as ISection } from "../../../types";
import useWindowDimensions from "../../util/useWindowDimensions";

const Aktuelles = ({
  data,
  bgData,
}: {
  data: ISection[];
  bgData: ISection[];
}) => {
  return (
    <PagesWrapper hasTop={false} data={bgData}>
      <div className={styles.head}>
        Alle Arbeiten sind verkäuflich - <br />
        Preise auf Anfrage <br />
        <br />
        Auftragsarbeiten - <br />
        werden entgegengenommen
      </div>
      <div className={styles.wrapper}>
        {data.map((image, index) => (
          <Section
            key={index}
            image={{
              images: image.pictures.map((p) => p.dataUrl),
              text: image.texts[0].content,
              text2: image.texts[1].content,
            }}
          />
        ))}
      </div>
    </PagesWrapper>
  );
};

const Section = ({
  image,
}: {
  image: { images: string[]; text: string; text2: string };
}) => {
  const { width } = useWindowDimensions();
  return (
    <div className={styles.section}>
      <div className={styles.text}>
        <p>{image.text}</p>
        <p>{image.text2}</p>
      </div>
      {image.images.map((image, index) => (
        <div className={styles.images}>
          <img
            src={image}
            alt={"Arbeit"}
            key={index}
            width={width < 768 ? width / 2 - 40 : (width - 8 * 10) / 8}
          />
        </div>
      ))}
    </div>
  );
};
export default Aktuelles;
